import React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const PricingTable = () => {
  const rows = [
    {
      jobType: 'Recreation',
      pricing: 'Simple - $6, Medium - $8, Complex - $10, Highly Complex - ( As per quote )'
    },
    {
      jobType: 'Digitizing',
      pricing: 'Per thousand stitches - $45 as per quote'
    },
    {
      jobType: 'Paper Proof',
      pricing: 'Per line item/templates - $45'
    },
  ];
  return (
    <Box
    className='jobWrapper'
    sx={{
      flex:1,
      ml:1
    }}>
    <Typography
    sx={{
        fontSize:"15px",
        fontWeight : '600',
        bgcolor : "#FFC88B",
        px:2,
        py:1.5,
        borderTopLeftRadius:'10px',
        borderTopRightRadius:'10px'
    }}>Pricing Table</Typography>
    <TableContainer 
    component={Paper} 
    sx={{
      borderTop : '0px!important',
      borderBottom : '10px'
    }}
      >
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead sx={{bgcolor : '#FFEEDB'}}>
          <TableRow>
            <TableCell>Job Type</TableCell>
            <TableCell>Pricing $</TableCell>
          </TableRow>
        </TableHead>
        <TableBody
        sx={{
          '& .MuiTableRow-root:nth-of-type(even)' : {
            bgcolor : '#FFEEDB'
          },
          '& .MuiTableCell-root' : {
            fontSize : '12px'
          }
        }}>
          {rows.map((row,idx) => (
            <TableRow
              key={idx}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.jobType}
              </TableCell>
              <TableCell>{row.pricing}</TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell component="th" scope="row"></TableCell>
            <TableCell component="th" scope="row"></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
   </Box>
  )
}

export default PricingTable
